import { Tooltip } from 'antd';
import type { ReactElement } from 'react';
import { TextTooltipContentEcho } from '@/components/tooltips/TextTooltipEcho';

interface YearLimitLabelProps {
  label: string;
  disabled: boolean;
}

/** Radio option label that explains, via a tooltip, that the option needs a date range of one year or less. */
const YearLimitLabel = ({ label, disabled }: YearLimitLabelProps): ReactElement => {
  if (!disabled) return <>{label}</>;

  return (
    <Tooltip
      placement="right"
      title={
        <TextTooltipContentEcho description="Only available for date ranges of one year or less. Choose a shorter range to use this." />
      }
    >
      <span>{label}</span>
    </Tooltip>
  );
};

export default YearLimitLabel;
